import { MasonryTrimKind } from "common/materials/masonryTypes";
import type { MaterialSrc } from "common/materials/materialSrc";

// A string identifying an exterior palette slot - and possibly a masonry trim variation.

export type ExteriorMaterial = keyof FullExteriorMaterials | ExteriorSlotAndTrimKind;

type ExteriorSlotAndTrimKind = (typeof masonrySlotPlusTrimKinds)[number];

export interface FullExteriorMaterials {
  readonly wallExterior0: MaterialSrc;
  readonly wallExterior1?: MaterialSrc;
  readonly wallExterior2?: MaterialSrc;
  readonly wallExterior3?: MaterialSrc;
  readonly wallExterior4?: MaterialSrc;
  readonly wallExterior5?: MaterialSrc;
  readonly wallExterior6?: MaterialSrc;
  readonly wallExterior7?: MaterialSrc;
  readonly wallExterior8?: MaterialSrc;
  readonly wallExterior9?: MaterialSrc;

  readonly trimExterior0: MaterialSrc;
  readonly trimExterior1?: MaterialSrc;
  readonly trimExterior2?: MaterialSrc;
  readonly trimExterior3?: MaterialSrc;
  readonly trimExterior4?: MaterialSrc;
  readonly trimExterior5?: MaterialSrc;
  readonly trimExterior6?: MaterialSrc;
  readonly trimExterior7?: MaterialSrc;
  readonly trimExterior8?: MaterialSrc;
  readonly trimExterior9?: MaterialSrc;

  readonly roof0: MaterialSrc;
  readonly roof1?: MaterialSrc;
  readonly roof2?: MaterialSrc;
  readonly roof3?: MaterialSrc;

  readonly roofTrim0: MaterialSrc;
  readonly roofTrim1?: MaterialSrc;
  readonly roofTrim2?: MaterialSrc;
  readonly roofTrim3?: MaterialSrc;

  readonly gutter0: MaterialSrc;
  readonly gutter1?: MaterialSrc;
  readonly gutter2?: MaterialSrc;

  readonly foundation0: MaterialSrc;
  readonly foundation1?: MaterialSrc;
  readonly foundation2?: MaterialSrc;

  readonly driveway0: MaterialSrc;
  readonly driveway1?: MaterialSrc;
  readonly driveway2?: MaterialSrc;

  readonly walks0: MaterialSrc;
  readonly walks1?: MaterialSrc;
  readonly walks2?: MaterialSrc;

  readonly porchCeiling0: MaterialSrc;
  readonly porchCeiling1?: MaterialSrc;
  readonly porchCeiling2?: MaterialSrc;

  readonly deck0: MaterialSrc;
  readonly deck1?: MaterialSrc;
  readonly deck2?: MaterialSrc;
  readonly deck3?: MaterialSrc;

  readonly glass0: MaterialSrc;
  readonly glass1?: MaterialSrc;
  readonly glass2?: MaterialSrc;

  readonly glassTrim0: MaterialSrc;
  readonly glassTrim1?: MaterialSrc;
  readonly glassTrim2?: MaterialSrc;

  readonly doorExterior0: MaterialSrc;
  readonly doorExterior1?: MaterialSrc;
  readonly doorExterior2?: MaterialSrc;
  readonly doorExterior3?: MaterialSrc;

  readonly garageExterior0: MaterialSrc;
  readonly garageExterior1?: MaterialSrc;
  readonly garageExterior2?: MaterialSrc;
  readonly garageExterior3?: MaterialSrc;

  readonly hardwareExterior0: MaterialSrc;
  readonly hardwareExterior1?: MaterialSrc;
  readonly hardwareExterior2?: MaterialSrc;

  readonly propDefault0: MaterialSrc;
  readonly propDefault1?: MaterialSrc;
  readonly propDefault2?: MaterialSrc;

  readonly masonry0: MaterialSrc;
  readonly masonry1?: MaterialSrc;
  readonly masonry2?: MaterialSrc;
  readonly masonry3?: MaterialSrc;

  readonly chimney0: MaterialSrc;
  readonly chimney1?: MaterialSrc;
  readonly chimney2?: MaterialSrc;

  readonly shutter0: MaterialSrc;
  readonly shutter1?: MaterialSrc;
  readonly shutter2?: MaterialSrc;

  readonly headCasing0: MaterialSrc;
  readonly headCasing1?: MaterialSrc;
  readonly headCasing2?: MaterialSrc;
  readonly headCasing3?: MaterialSrc;

  readonly apronCasing0: MaterialSrc;
  readonly apronCasing1?: MaterialSrc;
  readonly apronCasing2?: MaterialSrc;
  readonly apronCasing3?: MaterialSrc;

  readonly sideCasing0: MaterialSrc;
  readonly sideCasing1?: MaterialSrc;
  readonly sideCasing2?: MaterialSrc;
  readonly sideCasing3?: MaterialSrc;

  // Site materials
  readonly earth0: MaterialSrc;
  readonly road0: MaterialSrc;
  readonly grass0: MaterialSrc;
  readonly sidewalk0: MaterialSrc;
  readonly curb0: MaterialSrc;
  readonly fence0: MaterialSrc;
  readonly retainingWall0: MaterialSrc;
  readonly water0: MaterialSrc;
}

export const masonrySlotPlusTrimKinds = [
  `masonryTrim0:${MasonryTrimKind.Base}`,
  `masonryTrim0:${MasonryTrimKind.Header}`,
  `masonryTrim0:${MasonryTrimKind.Rowlock}`,

  `masonryTrim1:${MasonryTrimKind.Base}`,
  `masonryTrim1:${MasonryTrimKind.Header}`,
  `masonryTrim1:${MasonryTrimKind.Rowlock}`,

  `masonryTrim2:${MasonryTrimKind.Base}`,
  `masonryTrim2:${MasonryTrimKind.Header}`,
  `masonryTrim2:${MasonryTrimKind.Rowlock}`,

  `masonryTrim3:${MasonryTrimKind.Base}`,
  `masonryTrim3:${MasonryTrimKind.Header}`,
  `masonryTrim3:${MasonryTrimKind.Rowlock}`,
] as const;
